import { render, staticRenderFns } from "./CoffeeStock.vue?vue&type=template&id=2c2367dc&scoped=true"
import script from "./CoffeeStock.vue?vue&type=script&lang=js"
export * from "./CoffeeStock.vue?vue&type=script&lang=js"
import style0 from "./CoffeeStock.vue?vue&type=style&index=0&id=2c2367dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2367dc",
  null
  
)

export default component.exports